/**
 * @generated SignedSource<<e73d314fb6b4cb85bc9a4fa343b56a2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteUrlMappingInput = {
  clientMutationId?: string | null;
  urlMappingId: string;
};
export type UrlMappingListTabContainer_deleteMutation$variables = {
  input: DeleteUrlMappingInput;
  connections: ReadonlyArray<string>;
};
export type UrlMappingListTabContainer_deleteMutationVariables = UrlMappingListTabContainer_deleteMutation$variables;
export type UrlMappingListTabContainer_deleteMutation$data = {
  readonly deleteUrlMapping: {
    readonly deletedUrlMappingId: string;
  } | null;
};
export type UrlMappingListTabContainer_deleteMutationResponse = UrlMappingListTabContainer_deleteMutation$data;
export type UrlMappingListTabContainer_deleteMutation = {
  variables: UrlMappingListTabContainer_deleteMutationVariables;
  response: UrlMappingListTabContainer_deleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedUrlMappingId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingListTabContainer_deleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteUrlMappingPayload",
        "kind": "LinkedField",
        "name": "deleteUrlMapping",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UrlMappingListTabContainer_deleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteUrlMappingPayload",
        "kind": "LinkedField",
        "name": "deleteUrlMapping",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedUrlMappingId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "661b73a0cbbb63dd8dabca29e52bf2af",
    "id": null,
    "metadata": {},
    "name": "UrlMappingListTabContainer_deleteMutation",
    "operationKind": "mutation",
    "text": "mutation UrlMappingListTabContainer_deleteMutation(\n  $input: DeleteUrlMappingInput!\n) {\n  deleteUrlMapping(input: $input) {\n    deletedUrlMappingId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c269463644e5819c0ceff81085e0a84f";

export default node;
